var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B\\xE9n\\xE9ficaires",
    transform: "translate(-1305.000000, -211.000000)",
    stroke: "#5AADB2",
    strokeWidth: 0.9639
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(1306.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42857143,0 L6.42857143,2.88888889 C6.42857143,3.28776121 6.74836804,3.61111111 7.14285714,3.61111111 L10,3.61111111",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57142857,13 L1.42857143,13 C0.639593215,13 0,12.3533002 0,11.5555556 L0,1.44444444 C0,0.646699806 0.639593215,0 1.42857143,0 L6.42857143,0 L10,3.61111111 L10,11.5555556 C10,12.3533002 9.36040679,13 8.57142857,13 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.85714286,
    y1: 4.33333333,
    x2: 3.57142857,
    y2: 4.33333333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.85714286,
    y1: 7.22222222,
    x2: 7.14285714,
    y2: 7.22222222,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.85714286,
    y1: 10.1111111,
    x2: 7.14285714,
    y2: 10.1111111,
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a40c5528394abf5a5a674fd47805b927.svg";
export { ForwardRef as ReactComponent };